/**
 * Иконки блока «Исследуйте направления» на главной.
 * Положите файлы в client/public/home/directions/ (SVG или PNG).
 * Имя файла должно совпадать с ключом, например algorithms.svg.
 */
export const HOME_DIRECTION_ICON_PATHS = {
  algorithms: '/home/directions/algorithms.png',
  sql: '/home/directions/sql.png',
  math: '/home/directions/math.png',
  physics: '/home/directions/physics.png',
  ml: '/home/directions/ml.png',
  pandas: '/home/directions/pandas.png',
} as const;

export type HomeDirectionId = keyof typeof HOME_DIRECTION_ICON_PATHS;
